import * as actionTypes from './actionsTypes';

export const setCurrentPageSouscription = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_SOUSCRIPTION,
  payload: page
});

export const setValueSouscription = (value) => ({
  type: actionTypes.SET_VALUE_SOUSCRIPTION,
  payload: value
});

export const setSelectedOptionSouscription = (option) => ({
  type: actionTypes.SET_SELECTED_OPTION_SOUSCRIPTION,
  payload: option
});

export const setSortFieldSouscription = (field) => ({
  type: actionTypes.SET_SORT_FIELD_SOUSCRIPTION,
  payload: field
});

export const setOrderSouscription = (order) => ({
  type: actionTypes.SET_ORDER_SOUSCRIPTION,
  payload: order
});

export const setEnCoursSouscription = (value) => ({
  type: actionTypes.SET_EN_COURS_SOUSCRIPTION,
  payload: value
});

export const setValideesSouscription = (value) => ({
  type: actionTypes.SET_VALIDEES_SOUSCRIPTION,
  payload: value
});

export const setAnnuleesSouscription = (value) => ({
  type: actionTypes.SET_ANNULEES_SOUSCRIPTION,
  payload: value
});

export const setStatutSouscription = (statut) => ({
  type: actionTypes.SET_STATUT_SOUSCRIPTION,
  payload: statut
});

export const setCategorieSouscription = (categorie) => ({
  type: actionTypes.SET_CATEGORIE_SOUSCRIPTION,
  payload: categorie
});
